module.exports = __webpack_public_path__ + "be699349e45b468e0e7e32c3a53a027d.svg";